export default "__VITE_PUBLIC_ASSET__f6a79fe9__"